"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kode4Formblock = void 0;
const lit_element_1 = require("lit-element");
const class_map_1 = require("lit-html/directives/class-map");
const kode4_field_1 = require("./kode4-field");
let Kode4Formblock = class Kode4Formblock extends kode4_field_1.Kode4Field {
    get typeCssClass() {
        return 'kode4-formblock';
    }
    constructor() {
        super();
        this.canValidate = false;
    }
    get value() {
        return undefined;
    }
    set value(v) {
    }
    // --- RENDER -----------------
    render() {
        return lit_element_1.html `
            <div class="component ${class_map_1.classMap(this.cssClasses)}">
                <slot style="border: solid 2px #ccc;"></slot>
            </div>
        `;
    }
};
__decorate([
    lit_element_1.property()
], Kode4Formblock.prototype, "value", null);
Kode4Formblock = __decorate([
    lit_element_1.customElement('kode4-formblock')
], Kode4Formblock);
exports.Kode4Formblock = Kode4Formblock;
